<template>
  <section class="app-container">
    <invoice-title :titleType="formData.titleType" />
    <van-form validate-first @submit="onSubmit" @failed="onFailed" class="invoice">
      <van-field v-model="formData.email" required :rules="emailRules" placeholder="请输入电子邮箱" name="type" label="电子邮箱" />
      <div class="btn_box bottom">
        <van-button native-type="submit" size="large" class="blue-btn" @click="submitInvoice">
          重新发送
        </van-button>
      </div>
    </van-form>
  </section>
</template>

<script>
import {
  Form,
  Field,
  CellGroup,
  RadioGroup,
  Notify,
  Radio,
  Dialog,
  Popup
} from 'vant'
import { mapGetters } from 'vuex'
import { againSendEmail, SetIssuer } from '@/api/invoice'
export default {
  name: 'Invoice-Form',
  computed: {
    ...mapGetters([
      'pendingBill',//发票订单
      'invoiceToken',//发票token
    ])
  },

  components: {
    // InvoiceTitle,//用户抬头信息
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.Component.name]: Dialog.Component,
    [Popup.name]: Popup
  },
  data () {
    this.emailRules = [
      { required: true, message: '请输入邮箱' },
      { validator: this.emailValidator, message: '邮箱格式错误' },
    ];
    return {
      showOtherInfo: false,
      formData: {
        email: '',
        access_token: null,
        address: "",
        order_num: "",
      }
    }
  },
  mounted () {
    this.initFormData()
  },

  methods: {
    InvioceAgain (res) {
      console.log(this.pendingBill)
      let platformId = this.pendingBill.map(item => item.platformId)
      let outTradeNo = this.pendingBill.map(item => item.outTradeNo)
      let invoiceMerchant = this.pendingBill.map(item => item.invoiceMerchant)
      let invoiceNo = this.pendingBill.map(item => item.invoiceNo)
      let params = {
        email: this.formData.email,
        invoiceMerchant: invoiceMerchant.toString(),
        parkId: this.pendingBill[0].parkId,
        platformId: platformId.toString(),
        outTradeNo: outTradeNo.toString(),
        invoiceNum: invoiceNo.toString(),
        qpm: this.pendingBill[0].qpm
      }
      againSendEmail(params).then(res => {
        this.getInfo_Loading.clear()
        if (res.status == 1001) {
          this.$notify({
            type: 'success',
            message: res.message
          })
          this.$router.push({ name: 'Invoice-Result', query: { result: 'success' } })
        } else {
          this.$notify({
            type: 'danger',
            message: '开票失败，请联系管理员'
          })
          this.$router.push({ name: 'Invoice-Result', query: { result: 'fail' } })
        }
      }).catch(err => {
        this.getInfo_Loading.clear()
        this.$notify({
          type: 'danger',
          message: err
        })
        this.$router.push({ name: 'Invoice-Result', query: { result: 'fail' } })
      })
    },
    // 提交发票信息
    submitInvoice () {
      if (this.emailValidator(this.formData.email) == false) {
        Notify({ type: 'danger', message: '请完善信息' });
        return
      }
      this.getInfo_Loading = this.$toast.loading('加载中...')
      SetIssuer({ parkId: Number(this.pendingBill[0].parkId) }).then(res => {
        this.InvioceAgain(res)
      })
    },
    // 初始化表单数据
    initFormData () {
      let _this = this;
      if (!this.pendingBill || this.pendingBill.length === 0) {
        Dialog.alert({
          title: '数据过期失效',
          message: `请返回订单页面并重新选择`,
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: '立即选择',
          confirmButtonColor: '#1989fa',
          cancelButtonText: '返回主页'
        })
          .then(() => {
            // on close
            _this.$router.push({
              name: 'Invoice-History'
            })
          })
          .catch(() => {
            _this.$router.push({
              name: 'Personal-Center'
            })
          })
      }
    },
    // 校验函数返回 true 表示校验通过，false 表示不通过
    emailValidator (val) {
      return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(val);
    },
    onSubmit (values) {
      console.log('submit', values);
    },
    onFailed (errorInfo) {
      console.log('failed', errorInfo);
    },
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  height: 100vh;
  background-color: #f5f5f5;
  .invoice {
    &__otherInfo {
      /deep/ .van-cell__title,
      .van-cell__value {
        min-width: max-content;
      }
    }
  }
  .bottom_popup_box {
    height: 250px;
    display: flex;
    justify-content: flex-end; //space-evenly
    align-items: center;
    flex-direction: column;
    .bottom_popup_box_menu {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      height: 225px;
    }
  }
  .btn_box {
    width: calc(100vw - 30px);
    max-width: 600px;
  }
  .bottom {
    margin: 20px auto 20px;
  }
}
</style>